import React, { memo } from 'react';

import { SharedFooterProps } from '../../types/SharedFooterProps';
import { Actions } from '../Actions/Actions';
import { Layout } from '../Layout/Layout';

interface Props extends SharedFooterProps {
  /** Embedded footer */
  isEmbedded?: boolean;
}

export const Footer = memo(
  ({
    actions = [],
    children,
    enableBorder = true,
    isEmbedded = false,
    justify = 'flex-end',
    leftActions = [],
    leftContent,
    size = 'm',
  }: Props) => {
    const enableCustomContent = Boolean(children);

    const actionSize = size === 's' ? 's' : undefined;

    const content = enableCustomContent ? (
      children
    ) : (
      <Layout align="center" justify="space-between">
        {leftContent}
        {leftActions.length > 0 && (
          <Actions
            actions={leftActions}
            justify="flex-start"
            size={actionSize}
          />
        )}
        <Actions
          actions={actions}
          flex="auto"
          justify={justify}
          size={actionSize}
        />
      </Layout>
    );

    return (
      <Layout
        as="footer"
        borderTop={enableBorder ? 'border.divider' : undefined}
        styles={componentStyles.container({
          enableCustomContent,
          isEmbedded,
          size,
        })}
      >
        {content}
      </Layout>
    );
  },
);

const componentStyles = {
  container: ({
    enableCustomContent,
    isEmbedded,
    size,
  }: {
    enableCustomContent: boolean;
    isEmbedded: boolean;
    size: 's' | 'm';
  }) => {
    const isSmall = size === 's';
    const height = enableCustomContent
      ? 'fit-content'
      : isSmall
        ? 'footer.height.s'
        : 'footer.height';

    const px = isEmbedded ? 0 : isSmall ? 3 : 6;
    const py = enableCustomContent ? 3 : 0;

    return {
      flex: 'none',
      height,
      paddingBottom: py,
      paddingLeft: px,
      paddingRight: px,
      paddingTop: py,
      '> *': {
        width: '100%',
      },
    };
  },
};
